import React from 'react';
import { motion } from 'framer-motion';
const noNeeds = ['No necesitas cambiar toda tu vida en un día.', 'No necesitas comprar organizadores caros.', 'No necesitas limpiar toda la casa de una vez.', 'No necesitas tener mucho tiempo libre.', 'No necesitas hacerlo perfecto.'];
const steps = [{
  minutes: '15',
  label: 'minutos para despejar'
}, {
  minutes: '15',
  label: 'minutos para organizar'
}, {
  minutes: '15',
  label: 'minutos para reiniciar'
}];
export function Method() {
  return <section className="w-full bg-cocoa px-5 py-20 text-cream sm:px-8 sm:py-28" data-id="element-92" data-mp="3kh0bbp12fe19">
      <div className="mx-auto max-w-5xl" data-id="element-93" data-mp="3pgcu9yotg0yk">
        <div className="max-w-2xl" data-id="element-94" data-mp="3pfa63yivocmc">
          <p className="text-[0.7rem] uppercase tracking-[0.22em] text-sand/70" data-id="element-95" data-mp="3u7l3atm8hkb7">
            Sin perfeccionismo
          </p>
          <h2 className="mt-4 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-96" data-mp="2wspb8o371ie1">
            No necesitas hacerlo perfecto
          </h2>
          <ul className="mt-8 space-y-3" data-id="element-97" data-mp="31ppllb72t7ay">
            {noNeeds.map(line => <li key={line} className="text-lg leading-relaxed text-sand" data-id="element-98" data-mp="ped7608ve6qp">
                {line}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-2xl italic text-cream sm:text-3xl" data-id="element-99" data-mp="kio25he2zxn0">
            Solo necesitas empezar con pasos pequeños.
          </p>
        </div>

        <div className="mt-16 border-t border-cream/20 pt-12" data-id="element-100" data-mp="bni3r3h54hui">
          <h3 className="font-serif text-3xl text-cream sm:text-4xl" data-id="element-101" data-mp="6pga5om3904s">
            El método 15-15-15
          </h3>
          <div className="mt-8 grid gap-px overflow-hidden bg-cream/20 sm:grid-cols-3" data-id="element-102" data-mp="1osj52xv0jak">
            {steps.map((step, index) => <motion.div key={step.label} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-cocoa p-8" data-id="element-103" data-mp="3swetfef33k0e" data-mpi={index}>
                <p className="font-serif text-6xl text-clay" data-id="element-104" data-mp="3glvvyp0ogq1k">{step.minutes}</p>
                <p className="mt-2 text-base text-sand" data-id="element-105" data-mp="3gjsvtc5t9gj4">{step.label}</p>
              </motion.div>)}
          </div>
          <p className="mt-8 text-lg text-sand" data-id="element-106" data-mp="37lh9hmbz94wh">
            Un método simple para avanzar sin agotarte.
          </p>
        </div>
      </div>
    </section>;
}